import classNames from 'classnames/bind'
import styles from './EFLoading.module.scss'

const cx = classNames.bind(styles)
export function EFLoading({ isFixed = false }: { isFixed?: boolean }) {
  return (
    <div className={cx('loading-wrapper', { fixed: isFixed })}>
      <div className={cx('lds-ring')}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
